var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.iconClass,attrs:{"href":"#"},on:{"click":_vm.onClick}},[_c('d2-icon',{attrs:{"name":_vm.iconName}}),_vm._v(_vm._s(_vm.$enum('VlDiagState', _vm.mValue))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }